import React, {useEffect, useState} from "react";
import './CabinetHeader.css';
import buter from "../../../../static/img/Header/gamburger.svg";
import MainMenuClose from "../../../../static/img/Header/close.svg";
import HeaderLock from "../../../../static/img/Header/lock.svg";
import HeaderLockPhone from "../../../../static/img/Header/lockPhone.svg";
import axios from "axios";
import ExitTop from "../../../../static/img/Header/ExitTop.svg";
import ExitTopPhone from "../../../../static/img/Header/ExitTopPhone.svg";
import TopClientIn from "../../../../static/img/Header/TopClientIn.svg";
// import ChangeLink from "../../../ChangeLink/ChangeLink";
const PRERENDER_TEXTS = require("../../../../../prerender_base.js");


function CabinetHeader(props){
    const [userData, setuserData] = useState('');
    const [VisibleCabinet, setVisibleCabinet] = useState(false);

    useEffect(() => {
        window.addEventListener("message", (event) => {
            if (event.data === "reload") {
                window.location.reload();
            }
        });
        axios
            .get('https://my.profiforex.com/api/ajax/client/login-data', {withCredentials: true})
            .then((userData) => {
                    setuserData(userData.data);
                }
            )
            .catch(e => console.log(e));
        // window.__lc = window.__lc || {};
        // window.__lc.license = 12492213;
        // ;
        // (function(n,t,c){function i(n){return e._h?e._h.apply(null,n):e._q.push(n)}
        //     var e={_q:[],_h:null,_v:"2.0",on:function(){i(["on",c.call(arguments)])},once:function(){i(["once",c.call(arguments)])},off:function(){i(["off",c.call(arguments)])},get:function(){if(!e._h)throw new Error("[LiveChatWidget] You can't use getters before load.");return i(["get",c.call(arguments)])},call:function(){i(["call",c.call(arguments)])},
        //         init:function(){var n=t.createElement("script");
        //             n.async=!0// eslint-disable-line
        //                 ,n.type="text/javascript",n.src="https://cdn.livechatinc.com/tracking.js",// eslint-disable-line
        //                 t.head.appendChild(n)}};
        //     !n.__lc.asyncInit&&e.init()// eslint-disable-line
        //         ,n.LiveChatWidget=n.LiveChatWidget||e}(window,document,[].slice))// eslint-disable-line

    }, []);

    function IfEscIsPressCabinet(e) {
        if (e.keyCode === 27){
            setVisibleCabinet(!VisibleCabinet);}}
    function ChangeCabinetVisible() {setVisibleCabinet(!VisibleCabinet);}
    function ExitCabinet() {
        window.location.href = 'https://my.profiforex.com/?hash=none&redirect=' + window.location.href;
    }

     function TextSource(info) {
            try {return <>{JSON.parse(PRERENDER_TEXTS['HeaderCabinet'][info.ArrIndex])[props.lang] ? JSON.parse(PRERENDER_TEXTS['HeaderCabinet'][info.ArrIndex])[props.lang] : '*'+info.children}</>}
            catch (err) {return <>*{info.children}</>}
        }

        let EnterCabinet;
        if (userData) {EnterCabinet =
            <div className="CabinetInAutorization" >
                <div className="StandartPhone" >
                <div className="CabinetInAutorizationIn">
                    <a href="https://my.profiforex.com" target='_blank' rel="noopener noreferrer" ><div className="EnterCabinetLeft StandartPhone" ><img alt='alt' className="EnterCabinetLeftImg" src={TopClientIn} height="17"/> </div></a>
                    <div className="EnterCabinetRight StandartPhone" onClick={ExitCabinet.bind(this)} role="button" tabIndex={0}  ><img alt='alt' className="EnterCabinetLeftImg" src={ExitTopPhone} height="17"/> </div>
                </div>
                </div>
                <div className="StandartNoPhone" >
                <div className="CabinetInAutorizationIn" >
                    <nobr><a href="https://my.profiforex.com" target='_blank' rel="noopener noreferrer" >{(userData.Email.length > 25) ? (userData.Email.slice(0,20)+'...') : userData.Email}</a></nobr>
                    {/*<div className="StandartNoPhone" >bp239@yandex.ru</div>*/}
                    <div className="ButtonTransparencyInImgExit StandartNoPhone" onClick={ExitCabinet.bind(this)} role="button" tabIndex={0} ><img alt='alt' className="ButtonTransparencyInImgExitIMG" src={ExitTop} height="16"/></div>
                </div>
                </div>
            </div>
        } else {
        if (VisibleCabinet) {
            EnterCabinet =
                <div>
                    <div className="for_cab" role = "button" tabIndex={0} onClick={ChangeCabinetVisible.bind(this)}> </div>
                    <div className="cab_in">
                        <iframe src={"https://my.profiforex.com/iframe-auth/login/?lang="+props.lang} title='ProfiforexCabinetIFrame'
                                name="login" frameBorder="0" className="autoHeight-iframe" width="360px" height="430px"/>
                        <div className="iFrameCabinetCrest" role = "button" tabIndex={0} onClick={ChangeCabinetVisible.bind(this)}><img alt='Ifyoudontseeimages' src={MainMenuClose} width="24px" height="24px"/></div>
                        {/*<div className="iFrameCabinetLinks">*/}
                            {/*<div className="iFrameCabinetLinksElement"><ChangeLink lang={props.lang} to={'/account/open/'} ><TextSource ArrIndex= 'HeaderCabinet0000'>Регистрация</TextSource></ChangeLink></div>*/}
                            {/*<div className="iFrameCabinetLinksElement"><ChangeLink lang={props.lang} to={'/account/remind'} ><TextSource ArrIndex= 'HeaderCabinet0005'>Забыли пароль?</TextSource></ChangeLink></div>*/}
                        {/*</div>*/}
                    </div>
                </div>
        }
        else {EnterCabinet = <div className="HeaderPersonalArea">
            <div className="HeaderPersonalAreaIMG"  role = "button" tabIndex={0} onClick={ChangeCabinetVisible.bind(this)}><img src={HeaderLock}  alt='Ifyoudontseeimages' width='19px'/></div>
            <div className="HeaderPersonalAreaIMGPhone"  role = "button" tabIndex={0} onClick={ChangeCabinetVisible.bind(this)}><img src={HeaderLockPhone}  alt='Ifyoudontseeimages' width='19px'/></div>
            <div className="HeaderPersonalAreaText"  role = "button" tabIndex={0} onClick={ChangeCabinetVisible.bind(this)}><TextSource ArrIndex= 'HeaderCabinet0010'>Personal area</TextSource></div>
        </div>
        }}
        return (
            <div className="CabinetHeader"><input type="image" src={buter} onClick={ChangeCabinetVisible.bind(this)} onKeyUp={IfEscIsPressCabinet.bind(this)}  alt='alt'/>
                {EnterCabinet}
            </div>
        )}

export default CabinetHeader